import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { S_Link } from '../../design/links/S_Link';
import { ICurrentWorkspaceStore } from '../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { DecryptionScriptSampleModal } from '../components/DecryptionScriptSampleModal';

export const DecryptionScriptSampleContainer = observer((): ReactElement => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const { t } = useTranslator();

  const [showModal, setShowModal] = useState(false);

  const toggleModal = (): void => {
    setShowModal((prevState) => !prevState);
  };

  const isEncrypted = currentWorkspaceStore.currentWorkspace.encryption.encrypted || false;

  return (
    <>
      {isEncrypted && (
        <>
          <S_Link
            className='decrypt-link-sample'
            onClick={toggleModal}
            color={'anchor'}
          >
            {t('how_to_decrypt_files')}
          </S_Link>
          <DecryptionScriptSampleModal
            showDecryptionScriptSampleModal={showModal}
            onDecryptionScriptSampleModalCancel={toggleModal}
          />
        </>
      )}
    </>
  );
});
